
import * as debug_TestNavigation from './testnavigation';
import * as debug_TestRenderer from './testrenderer';

export namespace debug {
    export import TestRenderer = debug_TestRenderer.TestRenderer;
    export import TestNavigation = debug_TestNavigation.TestNavigation;
}
